/* eslint-disable import/prefer-default-export */
import { NAME } from './types';

export const plan = {
  getData: state => state[NAME].data,
};
